<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  role?: string;
}

const props = defineProps<Props>();
const emit = defineEmits<{ exit: [] }>();

interface RoleConfig {
  bg: string;
  label: string;
}

const config = computed<RoleConfig>(() => {
  const configs: Record<string, RoleConfig> = {
    landlord: { bg: 'bg-primary-800', label: 'Landlord (Full Access)' },
    tenant: { bg: 'bg-green-700', label: 'Tenant (Limited View)' },
    accountant: { bg: 'bg-purple-700', label: 'Accountant (Read-Only)' },
  };
  return configs[props.role || ''] || { bg: 'bg-gray-700', label: 'Unknown' };
});
</script>

<template>
  <div
    :class="[config.bg, 'fixed top-0 left-0 right-0 z-50 text-white text-center py-2 text-sm font-semibold shadow-nav']"
    data-testid="demo-mode-banner"
  >
    <span class="inline-flex items-center gap-2">
      <svg class="w-4 h-4 opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
      <span class="uppercase tracking-wider text-xs">Demo Mode</span>
      <span class="text-white/60">&middot;</span>
      {{ config.label }}
      <button @click="emit('exit')" class="ml-3 px-3 py-2 min-h-[44px] min-w-[44px] inline-flex items-center bg-white/15 rounded-lg hover:bg-white/25 transition-colors text-xs font-semibold">
        Exit Demo
      </button>
    </span>
  </div>
</template>
